import { Helmet } from "react-helmet-async";
import AdvancedSEOHead from "@/components/seo/AdvancedSEOHead";
import StructuredData from "@/components/seo/StructuredData";
import LLMFriendlyContent, { defaultPageFacts } from "@/components/seo/LLMFriendlyContent";
import { pageSEO } from "@/lib/seo";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ArrowLeft } from "lucide-react";
import { useNavigate, Link } from "react-router-dom";

export default function Cases() {
  const navigate = useNavigate();
  
  return (
    <>
      <AdvancedSEOHead
        title={pageSEO.cases.title}
        description={pageSEO.cases.description}
        canonical={pageSEO.cases.canonical}
        ogImage="/og/cases-1200x630.jpg"
        ogType="website"
        keywords={pageSEO.cases.keywords}
        breadcrumbs={[
          { name: "Études de cas", url: "/cases" }
        ]}
      />

      {/* Cases structured data */}
      <StructuredData 
        enableOrganization={false}
        enableWebsite={false}
        enableBreadcrumbs={true}
      />

      <main className="min-h-screen bg-background">
        {/* LLM-friendly content */}
        <div className="container mx-auto px-4 py-8">
        </div>

        {/* Hero Section */}
        <section className="py-12 lg:py-16 xl:py-20 relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-card/10 via-transparent to-card/10" />
          <div className="container mx-auto px-6 xl:px-8 2xl:px-12 relative">
            <div className="max-w-4xl xl:max-w-5xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl xl:text-6xl 2xl:text-7xl font-bold tracking-tight mb-6 bg-gradient-to-r from-foreground to-foreground/70 bg-clip-text text-transparent">
                Études de cas
              </h1>
              <p className="text-xl xl:text-2xl text-muted-foreground mb-8 leading-relaxed max-w-3xl mx-auto">
                Deux parcours : Amazon ou Creative Strategist.
              </p>
              
              {/* Scroll indicator */}
              <div className="flex flex-col items-center mt-12 lg:mt-16">
                <p className="text-sm text-muted-foreground mb-3">Explorez nos réalisations</p>
                <div className="w-6 h-10 border-2 border-primary/30 rounded-full flex justify-center">
                  <div className="w-1 h-3 bg-primary rounded-full mt-2 animate-bounce"></div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Cards Section */}
        <section className="py-16">
          <div className="container mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
              <Card className="p-8 border-border bg-card hover:bg-card/80 transition-colors duration-200 cursor-pointer" onClick={() => navigate("/cases/amazon")}>
                <div className="mb-4">
                  <Badge variant="outline" className="text-primary border-primary/30 bg-primary/10">
                    Amazon
                  </Badge>
                </div>
                <h3 className="text-2xl font-bold mb-3">Études Amazon</h3>
                <p className="text-muted-foreground mb-6">SEO & sémantique, A+, Stores, Ads, Ops & Buy Box</p>
                <Button variant="outline" className="w-full">
                  Voir les études
                </Button>
              </Card>

              <Card className="p-8 border-border bg-card hover:bg-card/80 transition-colors duration-200 cursor-pointer" onClick={() => navigate("/cases/creative")}>
                <div className="mb-4">
                  <Badge variant="outline" className="text-primary border-primary/30 bg-primary/10">
                    Creative
                  </Badge>
                </div>
                <h3 className="text-2xl font-bold mb-3">Creative Strategist</h3>
                <p className="text-muted-foreground mb-6">Positionnement, identité, packaging & assets</p>
                <Button variant="outline" className="w-full">
                  Voir les études
                </Button>
              </Card>
            </div>
          </div>
        </section>

        {/* Note Section */}
        <section className="py-16 bg-card/30">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto">
              <Card className="p-6 border-primary/20 bg-primary/5 text-center">
                <p className="text-foreground font-medium">
                  Aperçu non exhaustif — nombreux projets sous NDA pour préserver l'avantage compétitif des marques.
                </p>
              </Card>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}